import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  container: css`
    display: flex;
    flex: 1;
    flex-direction: column;
    width: 100%;
  `,
  activityDescription: css`
    background: #f7f7f7;
    padding: 8px 16px;
  `,
  contentColumn: css`
    display: flex;
    flex-direction: row;
    justify-content: space-between ;
    padding: 4px 16px 16px;
    @media (min-width: 800px) {
      padding: 10px 24px 24px;
    }
  `,
  flyerDetailsInfo: css`
    padding: 0px 16px 8px 16px;
    @media (min-width: 800px) {
      padding: 0px 24px 0px 24px;
    }
    display: flex;
    flex-direction: column;
  `,
  title: css`
    position: sticky;
    z-index: 1;
    background: ${colors.white};
    color: ${colors.prussian};
  `,
  section: css`
    padding: 20px;
  `,
  titleContainer: css`
    margin-bottom: 32px;
    position: sticky;
    z-index: 1;
    transition: top 0.2s ease-out;
    background: ${colors.white};
    display: flex;
    flex-direction: column;
    gap: 4px
  `,
  flyerId: css`
    font-size: 0.7rem;
    color: ${colors.prussian};
    margin-top: 1.33rem;
  `,
  infoSection: css`
    display: flex;
    align-items: flex-start;
    color: ${colors.prussian};
    margin-bottom: 15px;
  `,
  iconContainer: css`
    padding-right: 15px;
    img {
      width: ${pxToRem(22)};
      height: ${pxToRem(22)};
    }
  `,
  metricts: css`
    display: flex;
    flex-direction: row;
    padding-bottom: 15px;
    margin-bottom: 17px;
    border-bottom: 1px solid ${colors.silver};
  `,
  infoContainer: css`
    display: flex;
    flex-direction: column;
    /* font-size: 14px; */
  `,
  textGray: css`
    color: ${colors.slate};
  `,
  link: css`
    color: ${colors.jungle};
    text-decoration: underline;
  `,
  textLink: css`
    text-transform: lowercase;
    text-decoration: underline;
    padding-top: 4px;
    cursor: pointer;
  `,
  profileLink: css`
    color: ${colors.jungle};
    text-decoration: none;
    cursor: pointer;
  `,
  bottomMargin: css`
    margin-top: 80px;
  `,
  bottomContainer: css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row;
    z-index: 9999;
    padding: 15px;
    position: fixed;
    background-color: ${colors.white};
    bottom: 0;
    width: 100%;
    max-width: 748px;
    box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.296028);
    font-size: 14px;
    color: ${colors.prussian};
  `,
  timeLeftText: css`
    font-weight: bold;
  `,
  learnMoreLink: css`
    color: ${colors.jungle};
    padding-right: 15px;
    text-decoration: none;
  `,
  orgName: css`
    color: ${colors.jungle};
  `,
  flex: css`
    display: flex;
  `,
  paddingChip: css`
    padding-bottom: 16px;
  `,
  expiredDate: css`
    font-size: 14px;
    color: ${colors.red};
  `,
  byOrgName: css`
    font-size: 13px;
  `,
  disclaimerSpacing: css`
    padding-bottom: 12px;
  `,
  postedBy: css`
    padding-bottom: 4px;
  `,
  accessibleVersion: css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 16px;
    gap: 22px;
  `,
};

export default styles;
